import "./App.css";
import Navbar from "./components/Navbar";
import {
  Box,
  Button,
  Center,
  Divider,
  Flex,
  Grid,
  GridItem,
  Heading,
  HStack,
  Image,
  Input,
  Link,
  Text,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import { Icon } from "@chakra-ui/react";
import { AiFillGithub } from "react-icons/ai";
import { AiFillLinkedin } from "react-icons/ai";
import { AiOutlineMail } from "react-icons/ai";
import { SiGithub, SiGmail, SiLinkedin, SiNetlify } from "react-icons/si";
import { IoLocationSharp } from "react-icons/io5";
import { BsFillTelephoneFill } from "react-icons/bs";
import GitHubCalendar from "react-github-calendar";
import resume from "./Rajesh-Pachika-Resume.pdf";

function App() {
  return (
    <div>
      <Navbar />

      <Box
        backgroundColor="#00203FFF"
        width="100%"
        fontFamily="sans-serif"
        paddingBottom={["10px", "30px"]}
      >
        <Flex
          pt={["100px", "100px"]}
          verticalAlign="center"
          flexWrap="wrap"
          maxW="900px"
          margin="auto"
          id="home"
        >
          <Box margin="auto">
            <Image
              src="https://avatars.githubusercontent.com/u/105877055?v=4"
              borderRadius="50%"
              w={["230px", "250px", "270px"]}
            />
          </Box>
          <Box textAlign="center" margin="auto">
            <Box>
              <HStack
                w={["200px", "400px", "500px"]}
                flexWrap="wrap"
                m="auto"
                justifyContent="center"
                mt={["15px", "0px"]}
              >
                <Box>
                  <Text color="#cecece" fontSize={["23px", "27px", "30px"]}>
                    Hello my name is
                  </Text>
                </Box>
                <Box>
                  <Text
                    fontWeight="bold"
                    fontSize={["25px", "34px", "40px"]}
                    color="#DB4437"
                    m="auto"
                  >
                    Rajesh
                  </Text>
                </Box>
              </HStack>
              <HStack
                w={["250px", "400px", "500px"]}
                flexWrap="wrap"
                m="auto"
                justifyContent="center"
                mt={["15px", "0px"]}
              >
                <Box>
                  <Text
                    fontWeight="bold"
                    fontSize={["25px", "34px", "40px"]}
                    color="#DB4437"
                    m="auto"
                  >
                    Full Stack Web Developer
                  </Text>
                </Box>
              </HStack>
              <Box>
                <HStack
                  maxW={["250px", "300px", "370px"]}
                  margin="15px auto"
                  diasply="flex"
                  justifyContent="space-between"
                >
                  <Link
                    href="https://github.com/Rajesh-07-P"
                    target="_blank"
                    w={["40px", "60px", "80px"]}
                    h={["40px", "60px", "80px"]}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Icon
                      as={AiFillGithub}
                      w={["100%", "60%"]}
                      h={["100%", "60%"]}
                      color="white"
                      _hover={{ w: "100%", h: "100%" }}
                      display="inline-block"
                      transition="0.18s"
                    />
                  </Link>
                  <Link
                    href="https://www.linkedin.com/in/rajesh-reddy-5aa8a412a/"
                    target="_blank"
                    w={["40px", "60px", "80px"]}
                    h={["40px", "60px", "80px"]}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Icon
                      as={AiFillLinkedin}
                      w={["100%", "60%"]}
                      h={["100%", "60%"]}
                      color="lightblue"
                      _hover={{ w: "100%", h: "100%" }}
                      transition="0.18s"
                    />
                  </Link>
                  <Link
                    w={["40px", "60px", "80px"]}
                    h={["40px", "60px", "80px"]}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Icon
                      as={AiOutlineMail}
                      w={["100%", "60%"]}
                      h={["100%", "60%"]}
                      color="#DB4437"
                      _hover={{ w: "100%", h: "100%" }}
                      display="block"
                      transition="0.18s"
                    />
                  </Link>
                  <Link
                    bgColor="#DB4437"
                    color="white"
                    fontSize="20px"
                    p="8px 20px"
                    borderRadius="6"
                    cursor="pointer"
                    _hover={{
                      bgColor: "white",
                      color: "#DB4437",
                    }}
                    transition="0.4s"
                    href={resume}
                    download
                  >
                    Resume
                  </Link>
                </HStack>
              </Box>
            </Box>
          </Box>
        </Flex>
        <Divider
          borderBottom="1px solid grey"
          width="98%"
          pt={["50px", "100px"]}
          id="about"
        ></Divider>
        <Heading
          color="rgb(219, 210, 210)"
          as="h1"
          mt="50px"
          textAlign="center"
        >
          About Me
        </Heading>
        <Text
          color="#cecece"
          fontSize={["15px", "17px", "20px"]}
          maxW="800px"
          m="20px auto 0px"
          p="20px"
          textAlign="justify"
          fontWeight="100"
        >
          Having delved into web development just a year and a half ago, I bring
          forth a robust set of technical abilities alongside a disciplined work
          ethic, thriving in environments that demand minimal supervision.
          Throughout this journey, I've crafted numerous applications,
          undertaken substantial projects, and gained invaluable experience
          through live project engagements. Continuously honing my skills, I
          remain dedicated to pushing boundaries and delivering innovative
          solutions in the dynamic field of web development.
        </Text>
        <Text></Text>
        <Divider
          borderBottom="1px solid grey"
          width="98%"
          pt="70px"
          id="skills"
        ></Divider>
        <Heading
          color="rgb(219, 210, 210)"
          as="h1"
          mt="50px"
          textAlign="center"
        >
          Skills
        </Heading>
        <Grid
          templateColumns={["repeat(2,1fr)", "repeat(3,1fr)", "repeat(4,1fr)"]}
          gap="40px"
          maxWidth="900px"
          margin="auto"
          mt="40px"
          p={["20px", "50px", "20px"]}
        >
          <GridItem>
            <Center>
              <Image
                src="https://cdn-icons-png.flaticon.com/512/919/919827.png"
                boxSize={["60px", "70px", "80px"]}
                bgColor="white"
              />
            </Center>
            <Text
              color="white"
              fontSize={["15px", "17px", "20px"]}
              textAlign="center"
            >
              HTML
            </Text>
          </GridItem>
          <GridItem>
            <Center>
              <Image
                src="https://cdn-icons-png.flaticon.com/512/919/919826.png"
                boxSize={["60px", "70px", "80px"]}
                bgColor="white"
              />
            </Center>
            <Text
              color="white"
              fontSize={["15px", "17px", "20px"]}
              textAlign="center"
            >
              {" "}
              CSS
            </Text>
          </GridItem>
          <GridItem>
            <Center>
              <Image
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSV-nkWSx_ggFwSsr8P8QbmpBtG45JTN8iFuQ&usqp=CAU"
                boxSize={["60px", "70px", "80px"]}
              />
            </Center>
            <Text
              color="white"
              fontSize={["15px", "17px", "20px"]}
              textAlign="center"
            >
              JavaScript
            </Text>
          </GridItem>
          <GridItem>
            <Center>
              <Image
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png"
                boxSize={["60px", "70px", "80px"]}
              />
            </Center>
            <Text
              color="white"
              fontSize={["15px", "17px", "20px"]}
              textAlign="center"
            >
              React
            </Text>
          </GridItem>
          <GridItem>
            <Center>
              <Image
                src="https://img.icons8.com/?id=r9QJ0VFFrn7T&size=2x"
                boxSize={["60px", "70px", "80px"]}
              />
            </Center>
            <Text
              color="white"
              fontSize={["15px", "17px", "20px"]}
              textAlign="center"
            >
              chakra UI
            </Text>
          </GridItem>
          <GridItem>
            <Center>
              <Image
                src="https://ui-lib.com/blog/wp-content/uploads/2021/12/nextjs-boilerplate-logo.png"
                boxSize={["60px", "70px", "80px"]}
              />
            </Center>
            <Text
              color="white"
              fontSize={["15px", "17px", "20px"]}
              textAlign="center"
            >
              Next JS
            </Text>
          </GridItem>
          <GridItem>
            <Center>
              <Image
                src="https://cdn-icons-png.flaticon.com/512/5968/5968381.png"
                boxSize={["60px", "70px", "80px"]}
              />
            </Center>
            <Text
              color="white"
              fontSize={["15px", "17px", "20px"]}
              textAlign="center"
            >
              TypeScript
            </Text>
          </GridItem>
          <GridItem>
            <Center>
              <Image
                src="https://img.icons8.com/fluency/1x/node-js.png"
                boxSize={["60px", "70px", "80px"]}
                bgColor="white"
              />
            </Center>
            <Text
              color="white"
              fontSize={["15px", "17px", "20px"]}
              textAlign="center"
            >
              Node JS
            </Text>
          </GridItem>
          <GridItem>
            <Center>
              <Image
                src="https://img.icons8.com/ios/1x/express-js.png"
                boxSize={["60px", "70px", "80px"]}
                bgColor="white"
              />
            </Center>
            <Text
              color="white"
              fontSize={["15px", "17px", "20px"]}
              textAlign="center"
            >
              Express JS
            </Text>
          </GridItem>
          <GridItem>
            <Center>
              <Image
                src="https://raw.githubusercontent.com/iammostak/iammostak.github.io/main/src/assets/logos/redux.png"
                boxSize={["60px", "70px", "80px"]}
                bgColor="white"
              />
            </Center>
            <Text
              color="white"
              fontSize={["15px", "17px", "20px"]}
              textAlign="center"
            >
              Redux
            </Text>
          </GridItem>
          <GridItem>
            <Center>
              <Image
                src="https://raw.githubusercontent.com/iammostak/iammostak.github.io/main/src/assets/logos/mongoose-ii.png"
                boxSize={["60px", "70px", "80px"]}
                bgColor="white"
              />
            </Center>
            <Text
              color="white"
              fontSize={["15px", "17px", "20px"]}
              textAlign="center"
            >
              Mongoose
            </Text>
          </GridItem>
        </Grid>
        <Heading
          color="rgb(219, 210, 210)"
          as="h1"
          mt="50px"
          textAlign="center"
        >
          Tools
        </Heading>
        <Grid
          templateColumns={["repeat(2,1fr)", "repeat(3,1fr)", "repeat(4,1fr)"]}
          gap="40px"
          maxWidth="900px"
          margin="auto"
          mt="40px"
          p={["20px", "50px", "20px"]}
        >
          <GridItem>
            <Center>
              <Image
                src="https://cdn.iconscout.com/icon/free/png-256/mongodb-4-1175139.png?f=avif&w=128"
                boxSize={["60px", "70px", "80px"]}
                bgColor="white"
              />
            </Center>
            <Text
              color="white"
              fontSize={["15px", "17px", "20px"]}
              textAlign="center"
            >
              mongo DB
            </Text>
          </GridItem>
          <GridItem>
            <Center>
              <Image
                src="https://img.icons8.com/fluency/1x/visual-studio.png"
                boxSize={["60px", "70px", "80px"]}
                bgColor="white"
              />
            </Center>
            <Text
              color="white"
              fontSize={["15px", "17px", "20px"]}
              textAlign="center"
            >
              VS code
            </Text>
          </GridItem>
          <GridItem>
            <Center>
              <Image
                src="https://img.icons8.com/ios-filled/1x/github.png"
                boxSize={["60px", "70px", "80px"]}
                bgColor="white"
              />
            </Center>
            <Text
              color="white"
              fontSize={["15px", "17px", "20px"]}
              textAlign="center"
            >
              Github
            </Text>
          </GridItem>
          <GridItem>
            <Center>
              <Image
                src="https://img.icons8.com/color/1x/git.png"
                boxSize={["60px", "70px", "80px"]}
              />
            </Center>
            <Text
              color="white"
              fontSize={["15px", "17px", "20px"]}
              textAlign="center"
            >
              Git
            </Text>
          </GridItem>
        </Grid>
        <Divider
          borderBottom="1px solid grey"
          width="98%"
          pt={["40px", "100px"]}
          id="projects"
        ></Divider>
        <Heading color="rgb(219, 210, 210)" mt="50px" textAlign="center">
          Projects
        </Heading>
        <Grid
          templateColumns={["repeat(1,1fr)", "repeat(1,1fr)", "repeat(2,1fr)"]}
          maxW="1000px"
          m="30px auto"
          gap="20px"
          padding="20px"
        >
          <GridItem
            bgColor="white"
            p={["5px", "7px", "10px"]}
            borderRadius="4px"
            textAlign={"center"}
          >
            <Image
              src="https://i.postimg.cc/t4RTCFV4/latelyai.png"
              w="100%"
              h={["150px", "220px"]}
              boxShadow="lg"
              borderRadius="4px"
            />
            <Text fontSize="25px" textAlign={"center"}>
              Lately.ai
            </Text>
            <Text fontSize={["12px", "16px"]}>
              Lately.ai generates social content for
              <br /> specific audience.
              <br /> A static website where a user can login and check various
              content pages on content generation.
            </Text>
            <Text mt="10px">Tech-stack</Text>
            <Center mt="10px">
              <HStack>
                <Text bgColor="lightblue" p="2px 6px" borderRadius="4px">
                  HTML
                </Text>
                <Text bgColor="lightblue" p="2px 6px" borderRadius="4px">
                  CSS
                </Text>
                <Text bgColor="lightblue" p="2px 6px" borderRadius="4px">
                  JavaScript
                </Text>
              </HStack>
            </Center>
            <Center mt="10px" gap="20px">
              <Link
                href="https://dulcet-marigold-6dca17.netlify.app/"
                target={"_blank"}
                textDecor="none"
                fontSize="17px"
                border="2px solid black"
                p="2px 6px"
                borderRadius="6px"
                _hover={{ textDecoration: "none" }}
              >
                <Flex alignItems={"center"} gap="5px">
                  Live
                  <SiNetlify />{" "}
                </Flex>
              </Link>
              <Link
                href="https://github.com/capitalN/lately.ai"
                target={"_blank"}
                textDecor="none"
                fontSize="17px"
                border="2px solid black"
                p="2px"
                borderRadius="6px"
                _hover={{ textDecoration: "none" }}
              >
                <Flex alignItems={"center"} gap="5px">
                  GITHUB
                  <AiFillGithub />{" "}
                </Flex>
              </Link>
            </Center>
          </GridItem>
          <GridItem
            bgColor="white"
            p={["5px", "7px", "10px"]}
            borderRadius="4px"
            textAlign={"center"}
          >
            <Image
              src="https://i.postimg.cc/X7JWCcXZ/chargebee.png"
              w="100%"
              h={["150px", "220px"]}
              boxShadow="lg"
              borderRadius="4px"
            />
            <Text fontSize="25px">Chargebee.com</Text>
            <Text fontSize={["12px", "16px"]}>
              Chargebee is the subscription billing and revenue management
              platform.
              <br /> A static website where a user can login and check various
              subscription details on platform.
            </Text>
            <Text mt="10px">Tech-stack</Text>
            <Center mt="10px">
              <HStack>
                <Text bgColor="lightblue" p="2px 6px" borderRadius="4px">
                  Chakra.UI
                </Text>
                <Text bgColor="lightblue" p="2px 6px" borderRadius="4px">
                  React
                </Text>
              </HStack>
            </Center>
            <Center mt="10px" gap="20px">
              <Link
                href="https://fluffy-shelf-1478.vercel.app/"
                target={"_blank"}
                textDecor="none"
                fontSize="17px"
                border="2px solid black"
                p="2px 6px"
                borderRadius="6px"
                _hover={{ textDecoration: "none" }}
              >
                <Flex alignItems={"center"} gap="5px">
                  Live
                  <SiNetlify />{" "}
                </Flex>
              </Link>
              <Link
                href="https://github.com/Sunilkumar93/ChargeBee-Clone"
                target={"_blank"}
                textDecor="none"
                fontSize="17px"
                border="2px solid black"
                p="2px"
                borderRadius="6px"
                _hover={{ textDecoration: "none" }}
              >
                <Flex alignItems={"center"} gap="5px">
                  GITHUB
                  <AiFillGithub />{" "}
                </Flex>
              </Link>
            </Center>
          </GridItem>
          <GridItem
            bgColor="white"
            p={["5px", "7px", "10px"]}
            borderRadius="4px"
            textAlign={"center"}
          >
            <Image
              src="https://i.postimg.cc/X7MVDPfF/reliancedigital.png"
              w="100%"
              h={["150px", "220px"]}
              boxShadow="lg"
              borderRadius="4px"
            />
            <Text fontSize="25px">Relaince Digital</Text>
            <Text fontSize={["12px", "16px"]}>
              It is an ecommerce website that mainly sells electronic products.
              <br /> In this project admin can add products to backend. User
              details are along with his cart details are stored in backend.
            </Text>
            <Text mt="10px">Tech-stack</Text>
            <Center mt="10px">
              <HStack>
                <Text bgColor="lightblue" p="2px 6px" borderRadius="4px">
                  React
                </Text>
                <Text bgColor="lightblue" p="2px 6px" borderRadius="4px">
                  Node Js
                </Text>
              </HStack>
            </Center>
            <Center mt="10px" gap="20px">
              <Link
                href="https://statuesque-griffin-d59c36.netlify.app/"
                target={"_blank"}
                textDecor="none"
                fontSize="17px"
                border="2px solid black"
                p="2px 6px"
                borderRadius="6px"
                _hover={{ textDecoration: "none" }}
              >
                <Flex alignItems={"center"} gap="5px">
                  Live
                  <SiNetlify />{" "}
                </Flex>
              </Link>
              <Link
                href="https://github.com/Rajesh-P-07/fearful-humor-1273"
                target={"_blank"}
                textDecor="none"
                fontSize="17px"
                border="2px solid black"
                p="2px"
                borderRadius="6px"
                _hover={{ textDecoration: "none" }}
              >
                <Flex alignItems={"center"} gap="5px">
                  GITHUB
                  <AiFillGithub />{" "}
                </Flex>
              </Link>
            </Center>
          </GridItem>
        </Grid>
        <Divider borderBottom="1px solid grey" width="98%" pt="100px"></Divider>
        <Box bgColor="white" p="10px" maxWidth="1000px" margin="auto" mt="30px">
          <VStack>
            <Flex gap={"10px"}>
              <Image
                src="https://github-readme-stats.vercel.app/api/top-langs?username=Rajesh-07-P&show_icons=true&locale=en&layout=compact"
                w={"50%"}
              />
              <Image
                src="https://github-readme-stats.vercel.app/api?username=Rajesh-07-P&show_icons=true&locale=en"
                w={"50%"}
              />
            </Flex>
            <GitHubCalendar username="Rajesh-07-P" maxWidth="900px" />
          </VStack>
          <Box>
            <Heading>Git Stats</Heading>
          </Box>
        </Box>
        <Divider
          borderBottom="1px solid grey"
          width="98%"
          pt="100px"
          id="contact"
        ></Divider>
        <Center mt="60px">
          <Flex
            alignItems="center"
            justifyContent="center"
            maxW="700px"
            gap="40px"
            bg="white"
            p={["10px", "30px"]}
            borderRadius={"5px"}
            flexWrap="wrap"
          >
            <form>
              <VStack
                background="white"
                p={"30px"}
                boxShadow="2xl"
                borderRadius={"5px"}
                alignItems={"left"}
              >
                <label style={{ textAlign: "left" }}>Name</label>
                <Input
                  type={"text"}
                  placeholder="your name"
                  textAlign={"left"}
                  required
                  name="name"
                  className="form-control"
                />
                <label style={{ textAlign: "left" }}>Email</label>
                <Input
                  type={"email"}
                  placeholder="your email"
                  textAlign={"left"}
                  required
                  name="email"
                  className="form-control"
                />
                <label style={{ textAlign: "left" }}>Message</label>
                <Textarea
                  placeholder="type here..."
                  textAlign={"left"}
                  required
                  name="message"
                  className="form-control"
                />
                <Button
                  bgColor="#DB4437"
                  color="white"
                  fontSize="20px"
                  p="15px"
                  borderRadius="4"
                  cursor="pointer"
                  _hover={{
                    bgColor: "white",
                    color: "#DB4437",
                  }}
                  transition="0.4s"
                  mt="30px"
                  textAlign="start"
                  type="submit"
                  w="160px"
                  m="15px auto!important"
                >
                  Send Message
                </Button>
              </VStack>
            </form>
            <VStack justify={"space-between"}>
              <VStack color="black" gap="35px">
                <Heading size={"lg"}>CONTACT</Heading>
                <Link fontWeight={"bold"} width="100%">
                  <Flex
                    alignItems={"center"}
                    justifyContent="flex-start"
                    gap="15px"
                  >
                    <BsFillTelephoneFill />
                    +91 9963442006
                  </Flex>
                </Link>
                <Link fontWeight={"bold"} width="100%">
                  <Flex
                    alignItems={"center"}
                    justifyContent="flex-start"
                    gap="15px"
                  >
                    <SiGmail />
                    rajesh.pachika@gmail.com
                  </Flex>
                </Link>
                <Link
                  href="https://github.com/Rajesh-07-P"
                  target={"_blank"}
                  fontWeight={"bold"}
                  width="100%"
                >
                  <Flex
                    alignItems={"center"}
                    justifyContent="flex-start"
                    gap="15px"
                  >
                    <SiGithub />
                    Rajesh-07-P
                  </Flex>
                </Link>
                <Link
                  href="https://www.linkedin.com/in/rajesh-reddy-5aa8a412a/"
                  target={"_blank"}
                  fontWeight={"bold"}
                  width="100%"
                >
                  <Flex
                    alignItems={"center"}
                    justifyContent="flex-start"
                    gap="15px"
                  >
                    <SiLinkedin />
                    rajesh-reddy-5aa8a412a
                  </Flex>
                </Link>
                <Link fontWeight={"bold"} width="100%" target={"_blank"}>
                  <Flex
                    justifyContent="flex-start"
                    gap="15px"
                    alignItems={"center"}
                  >
                    <IoLocationSharp />
                    Hanamkonda, Telangana
                  </Flex>
                </Link>
              </VStack>
              <Divider />
              <HStack gap={"10px"}></HStack>
            </VStack>
          </Flex>
        </Center>
      </Box>
    </div>
  );
}

export default App;
